/**
 * Translations.
 */
export default {
  ACTION: {},
  ERROR: {
    DOWNLOAD_IMAGE: 'Não foi possível descarregar a imagem',
    ERROR: 'Erro'
  },
  HEADER: {
    DESCRIPTION: 'Descrição',
    END_DATE: 'Até',
    ID: 'Id',
    START_DATE: 'Desde',
    TITLE: 'Título'
  },
  LABEL: {
    ACTIVES: 'Campanhas ativas',
    CAMPAIGNS_SIGN_OR: 'Ou',
    CAMPAIGNS_SIGN_PLUS: '+',
    COUPON: 'Cupão',
    DESCRIPTION: 'Descrição',
    DESIGN_REQUESTS: 'Design',
    DESIGN_REQUESTS_ACTIVES: 'Designs ativos',
    DESIGN_REQUESTS_TERMINATED: 'Designs terminados',
    DETAIL: 'Detalhe',
    END_DATE: 'Até',
    FILES_TITLE: 'Recursos para a campanha',
    FILES_TITLE_DESIGN_REQUEST: 'Recursos para o design',
    FINISHED: 'Terminada',
    FINISHED_DESIGN_REQUEST: 'Terminado',
    GENERATED: 'Criada',
    GENERIC_DESIGN: 'Design genérico',
    ID: 'Id',
    IN_PROGRESS: 'Em progresso',
    NO_ROWS_CAMPAIGNS: 'Sem campanhas',
    NO_ROWS_DESIGN_REQUESTS: 'Sem designs',
    OFFER: 'Oferta',
    PREVIOUS_LEVEL: 'Patamar anterior',
    START_DATE: 'Desde',
    STATUS: 'Estado',
    TERMINATED: 'Campanhas terminadas',
    TITLE: 'Título',
    VALUE: 'Valor'
  },
  SENTENCE: {
    ATTACHMENT_DESCRIPTION: 'Sem anexos para esta campanha (ainda).',
    ATTACHMENT_DESCRIPTION_DESIGN_REQUEST:
      'Sem anexos para este pedido de design (ainda).',
    ATTACHMENT_TITLE: 'Sem anexos'
  },
  SUCCESS: {},
  TOOLTIP: {}
};
